import { PrismicSharpImage, TextFromRichText } from './PrismicTypes';

export const GENERIC_PROPERTY_SEARCH_HERO = 'PrismicGenericTemplateDataBodyPropertySearchHero';

export interface GenericPropertySearchHeroPrimary {
  main_title: TextFromRichText;
  subtitle: TextFromRichText;
  background_image_sharp: PrismicSharpImage;
  background_image_mobile: PrismicSharpImage;
}

export interface GenericPropertySearchHeroContent {
  __typename: typeof GENERIC_PROPERTY_SEARCH_HERO;
  primary: GenericPropertySearchHeroPrimary;
}
